'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Interests;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Interest = require('./Interest');

var _Interest2 = _interopRequireDefault(_Interest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'interests';

var DEFAULT_NUMBER_OF_INTERESTS_TO_SHOW = 3;

var getInterests = function getInterests(interests) {
  var showMore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (showMore) {
    return interests;
  }

  return interests.slice(0, DEFAULT_NUMBER_OF_INTERESTS_TO_SHOW);
};

function Interests(_ref) {
  var interests = _ref.interests,
      showMore = _ref.showMore,
      showMoreInterests = _ref.showMoreInterests;

  return _react2.default.createElement(
    'div',
    {
      className: CLASS_NAME
    },
    getInterests(interests, showMore).map(function (_ref2, key) {
      var label = _ref2.label,
          values = _ref2.values,
          id = _ref2.id,
          icon = _ref2.icon;
      return _react2.default.createElement(_Interest2.default, {
        key: key,
        label: label,
        values: values,
        icon: icon
      });
    }),
    _react2.default.createElement(
      'p',
      {
        className: CLASS_NAME + '-see-more',
        onClick: showMoreInterests
      },
      showMore ? "See Less −" : "See More +"
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobMatch/Content/Interests/Interests.jsx
// module id = 1192
// module chunks = 0